var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "代驾轨迹信息",
        visible: _vm.dialogRoadsVisible,
        width: "1000px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogRoadsVisible = $event
        },
      },
    },
    [
      _c("div", { staticClass: "map_app" }, [
        _c("div", { attrs: { id: "container" } }),
        _vm._v(" "),
        _c("div", { staticClass: "input-card" }, [
          _c("h4", [_vm._v("轨迹回放控制")]),
          _vm._v(" "),
          _c("div", { staticClass: "input-item" }, [
            _c("input", {
              staticClass: "btn",
              attrs: {
                type: "button",
                value: "开始",
                id: "start",
                onclick: "startAnimation()",
              },
            }),
            _vm._v(" "),
            _c("input", {
              staticClass: "btn",
              attrs: {
                type: "button",
                value: "暂停",
                id: "pause",
                onclick: "pauseAnimation()",
              },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "input-item" }, [
            _c("input", {
              staticClass: "btn",
              attrs: {
                type: "button",
                value: "继续",
                id: "resume",
                onclick: "resumeAnimation()",
              },
            }),
            _vm._v(" "),
            _c("input", {
              staticClass: "btn",
              attrs: {
                type: "button",
                value: "停止",
                id: "stop",
                onclick: "stopAnimation()",
              },
            }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }